import { render, staticRenderFns } from "./ClassroomRecord.vue?vue&type=template&id=78cfae18&scoped=true&"
import script from "./ClassroomRecord.vue?vue&type=script&lang=js&"
export * from "./ClassroomRecord.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomRecord.vue?vue&type=style&index=0&id=78cfae18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cfae18",
  null
  
)

export default component.exports